<!--
 * @Author: your name
 * @Date: 2022-05-31 09
-->
<template>
  <div class="shop">
    <div class="mapdetails" v-show="chinaadd">
      <div class="selectlist">
        <div class="select_input">
          <div class="icon el-icon-search"></div>
          <input type="text" v-model="state" placeholder="请选择地址" :disabled="true">
        </div>
        <!-- 查出来的列表 -->
        <div v-if="state" class="provincelist">
          <div class="provincerow" @click="linktoMap(item.city)" v-for="(item,index) in provincelist" :key="index">
            <div class="city">{{item.city}}</div>
          </div>
        </div>
      </div>
      <div id="map" class="maps" ></div>
    </div>
    <div class="maprow"  v-if="mapShow">
      <div class="mapinput">
        <div class="iconhref el-icon-back" @click="returnchani"></div>
        <div class="inputdetails">
          <input type="text" placeholder="" v-model="detailedRegion" :disabled="true">
          <div class="icon el-icon-search"></div>
        </div>
        <div class="totalTitle">一共找到{{RegionList.length}}个门店</div>
        <div class="addlist">
          <div class="adddetails" v-for="(item,index) in RegionList" :key="index" @click="mapClick(item)">
            <div class="addtop">
              <div class="addname">{{item.storeName}}</div>
              <div class="addphone">{{item.linkTel}}</div>
            </div>
            <div class="addcontent">{{item.addr}}</div>
          </div>
        </div>
      </div>
      <div class="dv" style="width:72%;height:100%;">
        <baidu-map :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true" style="width:100%;height:100%;">
          <bm-marker :position="{lng: item.lng, lat: item.lat}" :key="index" v-for="(item,index) in allMarkerList" @click="onhanderMarker(item)"></bm-marker>
          <bm-info-window :position="position" :width="360" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
            <div class="map-title">{{infoWindow.storeName}}</div>
            <div class="map-content">
              <div class="map-content-line"/>
                <div class="map-content-item" style="align-items: flex-start;">
                    <div class="map-content-item-title" style="width: 100px">门店形象图片：</div>
                    <div class="map-content-item-mark">
                      <img v-if="infoWindow.storePhoto" :src="infoWindow.storePhoto" class="map-content-item-mark-banner"/>
                    </div>
                </div>
              <div class="map-content-item">
                <div class="map-content-item-title">门店星级：</div>
                <div class="map-content-item-mark">
                    <div class="map-content-item-mark-start" v-for="n in infoWindow.grade?infoWindow.grade*1:1" :key="n"/>
                </div>
              </div>
              <div class="map-content-item">
                <div class="map-content-item-title">门店电话：</div>
                <div class="map-content-item-mark map-content-item-link">{{infoWindow.linkTel}}</div>
              </div>
              <div class="map-content-line"/>
              <div class="map-content-item">
                <div class="map-content-item-title">售后人员：</div>
                <div class="map-content-item-mark">{{infoWindow.serviceWorker}}</div>
              </div>
              <div class="map-content-item">
                <div class="map-content-item-title">售后电话：</div>
                <div class="map-content-item-mark map-content-item-link">{{infoWindow.supportphone}}</div>
              </div>
              <div class="map-content-line"/>
              <div class="map-content-item">
                <div class="map-content-item-title">门店地址：</div>
                <div class="map-content-item-mark">{{infoWindow.addr}}</div>
              </div>
            </div>
          </bm-info-window>
        </baidu-map>
      </div>
    </div>
  </div>
</template>
<script>
import chinaMap from '@/assets/get/map.json';
import { getStoresApi } from "../../../../request/api";
export default {
  name:'shop',
  data(){
    return{
      detailedRegion:'',
      restaurants: [],
      state: '',
      timeout:  null,
      center: {lng: 0, lat: 0},
      position:{lng: 0, lat: 0},
      infoWindow: {
        show: false,
        grade: 1,
      },
      zoom: 1,
      xmap:0,
      ymap:0,
      zooms:18,
      provincelist:[],
      RegionList:[],
      allMarkerList: [],
      mapShow:false,
      chinaadd:true,
      addressicon:require('@/assets/address.png')
    }
  },
  mounted(){
    this.chinaMap()
  },
  watch:{
    state(){
      this.keyup_submit(this.state)
    }
  },
  created(){
  },
  methods:{
    clear(){
      this.infoWindow.show = false
    },
    infoWindowOpen(){
      this.infoWindow.show = true
    },
    infoWindowClose(){
      this.infoWindow.show = false
    },
    keyup_submit(state){
      // 查询门店
        const data = {
          condition:state,
          locations:'',
          city:'',
          isFindGrade: 1
        }
        getStoresApi(data).then(({data})=>{
          let map = new Map();
          for (let item of data.result) {
              map.set(item.city, item);
          }
          this.provincelist = [...map.values()];
        })
    },
    mapClick(val){
      let obj = {lng:val.longitude,lat:val.latitude}
      this.center = obj
      this.position = obj
      this.infoWindow = {
        ...val,
        show: true
      }
    },
    onhanderMarker(item){
      let obj = {lng:item.lng,lat:item.lat}
      this.center = obj
      this.position = obj
      this.infoWindow = {
        ...item,
        show: true
      }
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    chinaMap() {
        let uploadedDataURL = chinaMap;
        let echarts = require("echarts");
        let myChart = echarts.init(document.getElementById('map'))
        var points = [
            { value: [118.8062, 31.9208], itemStyle: { color: '#00465d' } },
            { value: [127.9688, 45.368], itemStyle: { color: '#00465d' } },
            { value: [110.3467, 41.4899], itemStyle: { color: '#00465d' } },
            { value: [125.8154, 44.2584], itemStyle: { color: '#00465d' } },
            { value: [116.4551, 40.2539], itemStyle: { color: '#00465d' } },
            { value: [123.1238, 42.1216], itemStyle: { color: '#00465d' } },
            { value: [114.4995, 38.1006], itemStyle: { color: '#00465d' } },
            { value: [117.4219, 39.4189], itemStyle: { color: '#00465d' } },
            { value: [112.3352, 37.9413], itemStyle: { color: '#00465d' } },
            { value: [109.1162, 34.2004], itemStyle: { color: '#00465d' } },
            { value: [103.5901, 36.3043], itemStyle: { color: '#00465d' } },
            { value: [106.3586, 38.1775], itemStyle: { color: '#00465d' } },
            { value: [101.4038, 36.8207], itemStyle: { color: '#00465d' } },
            { value: [103.9526, 30.7617], itemStyle: { color: '#00465d' } },
            { value: [108.384366, 30.439702], itemStyle: { color: '#00465d' } },
            { value: [113.0823, 28.2568], itemStyle: { color: '#00465d' } },
            { value: [102.9199, 25.46639], itemStyle: { color: '#00465d' } },
            { value: [119.4543, 25.9222],itemStyle:{color:'#00465d'} },
        ];
        myChart.showLoading();
        let index = -1;

        var option
        echarts.registerMap('china', uploadedDataURL);
        myChart.hideLoading();
        option = {
            // backgroundColor: '#013954',
            width:'70%',
            legend:{
              textStyle:{
                fontSize:40,
                color:'#ffffff'
              }
            },
            geo: {
                map: 'china',
                regions: [
                    {
                        name: '南海诸岛',
                        itemStyle: {
                            areaColor: 'rgba(0, 10, 52, 1)',

                            borderColor: 'rgba(0, 10, 52, 1)',
                            normal: {
                                opacity: 0,
                                label: {
                                    show: false,
                                    color: '#009cc9',
                                },
                            },
                        },
                    },
                ],
            },
            series: [
                {
                    type: 'map',
                    roam: false,
                    label: {
                        normal: {
                            show: true,
                            textStyle: {
                                color: '#1DE9B6',
                            },
                        },
                        emphasis: {
                            textStyle: {
                                // color: 'rgb(183,185,14)',
                            },
                        },
                    },

                    itemStyle: {
                        normal: {
                            // borderColor: 'rgb(147, 235, 248)',
                            // borderWidth: 1,
                            areaColor: {
                                type: 'radial',
                                // x: 0.5,
                                // y: 0.5,
                                // r: 0.8,
                                colorStops: [
                                    // {
                                    //     offset: 0,
                                    //     color: '#fbf9dd', // 0% 处的颜色
                                    // },
                                    {
                                        offset: 1,
                                        color: '#fbf9dd', // 100% 处的颜色
                                    },
                                ],
                                //globalCoord: true, // 缺省为 false
                            },
                        },
                        emphasis: {
                            // areaColor: 'rgb(46,229,206)',
                            //    shadowColor: 'rgb(12,25,50)',
                            // borderWidth: 0.1,
                        },
                    },
                    // zoom: 12,
                    map: 'china', //使用
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    symbolSize: 2,
                    data: points,
                }, //地图线的动画效果
                {
                    type: 'lines',
                },
            ],
        };
        myChart.setOption(option, true);
        let that = this
        myChart.on('click',function(params){
          that.state = params.name
        })
    },
    // 地图
    handler({BMap, map}) {
      this.center.lng = this.xmap //经度
      this.center.lat = this.ymap//纬度
      this.zoom = this.zooms//比例
      // var marker = new BMap.Marker(new BMap.Point(this.xmap ,this.ymap ));
      // map.addOverlay(marker);
    },
    // 点击列表
    linktoMap(info){
      const data = {
        condition:'',
        locations:'',
        isFindGrade: 1,
        city:info
      }
      getStoresApi(data).then(({data})=>{
        this.mapShow = true
        this.chinaadd = false
        this.RegionList = data.result
        this.allMarkerList = this.RegionList.map(item=>{
          return {
            ...item,
            lng: item.longitude,
            lat: item.latitude,
          }
        })
        this.detailedRegion = info
        this.xmap = this.RegionList[0].longitude
        this.ymap = this.RegionList[0].latitude

      })
    },
    returnchani(){
      this.mapShow = false
      this.chinaadd = true
      this.$nextTick(()=>{
        this.chinaMap()
      })
    },
  },
}
</script>
<style lang="scss">
.shop{
  // max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  background: url("../../../assets/img/shop/shop-bg.jpg") center;
  background-size: 100% 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  .mapdetails{
    margin: 0 auto;
    width: 80%;
    display: flex;
    align-items: center;
    .selectlist{
      width: 20%;
      height: 300px;
      // .el-autocomplete{
        // width: 100%;
        .select_input{
          height: 45px;
          display: flex;
          align-items: center;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background-color: #00000044;
          width: 100%;
          border-bottom: 1px solid #FFF101;
          .icon{
            font-size: 22px;
            color: #FFF101;
            padding-left: 22px;
          }
          input{
            border: none;
            text-align: center;
            font-size: 14px;
            color: #ffffff;
            width: calc(100% - 44px);
            outline: none;
            height: 100%;
            background-color: #00000000;
            border-top-right-radius: 10px;
          }
          input::-webkit-input-placeholder{
            color: white;
          }
        }
        // 查出来的列表
        .provincelist{
          width: 100%;
          background: #00000044;
          max-height: 264px;
          overflow-y: auto;
          .provincerow{
            width: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            height: 44px;
            align-items: center;
            cursor: pointer;
            .city{
              font-size: 14px;
              color: #ffffff;
              margin-left: 5%;
            }
            .province{
              font-size: 14px;
              color: #ffffff;
              margin-right: 5%;
            }
          }
          .provincerow:hover{
            background-color: #FFF101;
            .province,.city{
              color:#000000;
            }
          }
        }
        .provincelist::-webkit-scrollbar{
          width: 5px;
          height: 5px;
        }
        .provincelist::-webkit-scrollbar-thumb{
          border-radius: 5px;
          -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
          background: rgba(0,0,0,0.1);
        }
        .provincelist::-webkit-scrollbar-track{
          -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
          border-radius: 0px;
          background: rgba(0,0,0,0.1);
        }
    }
  }
}

.maps{
  width: 80%;
  height: 788px;
}
.maprow{
  width: 95vw;
  height: 700px;
  display: flex;
  // padding-left: 20px;
  margin: 60px auto 0;
  background-color: rgba(255, 255, 255, 0.212);
  border-radius: 15px;
  .mapinput{
    width: 35%;
    padding: 10px;
    .iconhref{
      font-size: 30px;
      cursor: pointer;
      color: #FBCC0A;
    }
    .inputdetails{
      width: 100%;
      display: flex;
      height: 50px;
      border-bottom: 1px solid #FBCC0A;
      align-items: center;

      input{
        border: none;
        width: 90%;
        padding-left: 14px;
        outline: none;
        height: 50%;
        font-size: 14px;
        color: #ffffff;
        background-color: transparent;
      }
      .icon{
        font-size: 22px;
        color: #FBCC0A;
        margin-bottom: 3px;
      }
    }
    .totalTitle{
      padding-left: 14px;
      font-size: 14px;
      color: #ffffff;
      margin-top: 20px;
    }
    .addlist{
      max-height: 520px;
      overflow-y: auto;
      padding-bottom: 20px;
      .adddetails{
        margin: 0 auto;
        min-height: 79px;
        max-height: 110px;
        margin-top: 19px;
        cursor: pointer;
        .addtop{
          display: flex;
          justify-content: space-between;
          width: 92%;
          margin: 0 auto;
          padding-top: 17px;
          align-items: center;
          .addname{
            font-size: 16px;
            color: #ffffff;
          }
          .addphone{
            font-size: 16px;
            color: #ffffff;
          }
        }
        .addcontent{
          font-size: 14px;
          color: #ffffff;
          width: 92%;
          margin: 0 auto;
          margin-top: 15px;
        }
      }
      .adddetails:hover{
        background-color: #FBCC0A;
        .addname{
          color: #000000;
        }
        .addphone{
          color: #000000;
        }
        .addcontent{
          color: #555555;
        }
      }

    }
    .addlist::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    .addlist::-webkit-scrollbar-thumb{
      border-radius: 5px;
      -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
      background: rgba(0,0,0,0.1);
    }
    .addlist::-webkit-scrollbar-track{
      -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 0px;
      background: rgba(0,0,0,0.1);
    }

  }
}

// 二级导航
.navigationTow{
  width: 100%;
  height: 80px;
  background-color: #2F2F2F;
}
.map-title{
  width: 360px;
  font-size: 16px;
  font-weight: bold;
}
.map-content{
  display: flex;
  flex-direction: column;
  width: 360px;
  &-item{
    display: flex;
    align-items: baseline;
    font-size: 14px;
    &-title{
      width: 80px;
      flex-shrink: 0;
    }
    &-mark{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: right;
      &-banner{
        width: 120px;
        height: 80px;
        border-radius: 4px;
        margin-left: 10px;
      }
      &-banner:first-child{
        margin-left: 0;
      }
      &-start{
        width: 20px;
        height: 20px;
        margin-left: 10px;
        background: url('../../../assets/star.png') no-repeat;
        background-size: 100% 100%;
      }
      &-start:first-child{
        margin-left: 0;
      }
    }
    &-link{
      color: blue;
    }
  }
  &-line{
    margin: 2px 0;
    width: 100%;
    height: 1px;
    background-color: #dcd9d9;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/test-drive/shop/shop.vue